(function () {
    'use strict';

    const $activeFilters = $('.active-filters');
    const removeFiltersText =
        $('.vebego-container').data('remove-filters-text') || 'Wis filters';

    function renderActiveFilters() {
        $activeFilters.empty();

        const $checked = $('.left').find(
            'input[type="checkbox"]:checked, input[type="radio"]:checked'
        );
        const labels = new Set(); // voorkomt dubbele tags

        $checked.each(function () {
            const $input = $(this);
            const id = $input.attr('id');
            let labelText = '';

            // gekoppeld label
            if (id) {
                labelText = $(`label[for="${id}"]`).text().trim();
            }

            // fallback
            if (!labelText) {
                labelText = $input.closest('label').text().trim();
            }
            if (!labelText) {
                labelText = $input
                    .closest('.atm-form-checkbox, .atm-form-radio')
                    .find('.form-label, .atm-form-checkbox-label')
                    .text()
                    .trim();
            }
            if (!labelText) {
                labelText = $input.val() || 'Onbekend';
            }

            // skip als deze label al is toegevoegd
            if (labels.has(labelText)) return;
            labels.add(labelText);

            // tag markup
            const $tag = $(`
                <button class="filter-tag flex gap-3 items-center bg-white text-primary rounded-full text-sm font-display py-3 px-4 border border-primary hover:bg-primary hover:text-white transition-colors cursor-pointer" aria-label="Verwijder filter: ${labelText}">
                    <span>${labelText}</span>
                    <span class="font-bold">✕</span>
                </button>
            `);

            // verwijderactie
            $tag.on('click', function (e) {
                e.preventDefault();
                $input.prop('checked', false).trigger('change');
                renderActiveFilters();
            });

            $activeFilters.append($tag);
        });

        // Toon "Wis filters" button achteraan als er filters actief zijn
        if ($checked.length > 0) {
            const $clearButton = $(`
                <button class="clear-all-filters text-secondary-col-1 no-underline font-display px-4 py-3" aria-label="${removeFiltersText}">
                    <span>${removeFiltersText}</span>
                </button>
            `);

            $clearButton.on('click', function (e) {
                e.preventDefault();
                $('.left')
                    .find(
                        'input[type="checkbox"]:checked, input[type="radio"]:checked'
                    )
                    .prop('checked', false)
                    .trigger('change');
                renderActiveFilters();
            });

            $activeFilters.append($clearButton);
        }
    }

    // her-render bij wijzigingen
    $(document).on(
        'change',
        '.left input[type="checkbox"], .left input[type="radio"]',
        renderActiveFilters
    );
    renderActiveFilters();

    // ————— Jouw bestaande code blijft hieronder staan ————— //

    [...document.querySelectorAll('.wrapper-checkbox')].forEach(($el) => {
        const maxElements = $($el).find('.atm-form-checkbox').length;

        if (maxElements > 5) {
            $($el).find('.atm-form-checkbox:eq(4)').addClass('last-item');
        } else {
            $($el).find('.read-more').addClass('hide');
        }

        $($el)
            .find('.read-more')
            .on('click', function (e) {
                e.preventDefault();
                $($el)
                    .find('.atm-form-checkbox:eq(4)')
                    .removeClass('last-item');
                $($el).find('.read-less').removeClass('hide');
                $($el).find('.read-more').addClass('hide');
            });

        $($el)
            .find('.read-less')
            .on('click', function (e) {
                e.preventDefault();
                $($el).find('.atm-form-checkbox:eq(4)').addClass('last-item');
                $($el).find('.read-more').removeClass('hide');
                $($el).find('.read-less').addClass('hide');
            });
    });

    $('.mobile-filter-btn').on('click', function (e) {
        e.preventDefault();
        $('.left .modal').addClass('active');
        $('body').addClass('overflow');
    });

    $('.close-modal').on('click', function (e) {
        e.preventDefault();
        $('.left .modal').removeClass('active');
        $('body').removeClass('overflow');
    });
})();
